import React from "react";
import { Form } from "react-bootstrap";
import { loginUser } from "~/shared/auth-utils";
import { useParams } from 'react-router-dom';
import Page from "~/shared/Page";
import ControlledForm from "~/shared/form/ControlledForm";
import TextInput from "~/shared/form/TextInput";
import FormResponse from "~/shared/form/FormResponse";
import FloatingPanel from "~/shared/FloatingPanel";
import FormButton from "~/shared/form/FormButton";

/**
 * @param {Object} props
 * @param {"Admin" | "Staff"} props.type
 */
export default function CredentialsSetup({ type }) {
    const { token } = useParams();

    return (
        <Page title="Setup Credentials">
            <div className="page-container">
                <FloatingPanel red title="Create Password" size="max-w-lg">
                    <p className="mb-4">
                        Please set up your {type.toLowerCase()} account credentials below.
                    </p>
                    <ControlledForm onSubmit={data => data.token = token} post="auth/setup-credentials" onSuccess={({ token }) => loginUser(token)} redirect="/">
                        <div className="flex flex-col gap-3">
                            <TextInput label="Password" id="password" validate={(password, { confirm }) => password === confirm} invalid="Passwords must match." deps="confirm" placeholder="Enter password" preset="password" required>
                                <Form.Text>Password must be at least 8 characters long.</Form.Text>
                            </TextInput>
                            <TextInput label="Confirm Password" id="confirm" validate={(confirm, { password }) => password === confirm} invalid="Passwords must match." deps="password" placeholder="Confirm password" preset="password" required />
                        </div>
                        <FormResponse />
                        <FormButton legacy submit className="mt-4" />
                    </ControlledForm>
                </FloatingPanel>
            </div>
        </Page>
    );
}
